import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import Control from './control/item';
import SelectField from '../../../shared/form-elements/select/field';
import { Field, reduxForm } from 'redux-form';

const propTypes = {
	permissionsList: PropTypes.array,
	permissionsControlToggle: PropTypes.func,
	permissionControlToggleSelectValue: PropTypes.func,
	permissionsControlSave: PropTypes.func,
	permissionControlCancel: PropTypes.func,
	intl: PropTypes.func,
	routeParams: PropTypes.object,
	can: PropTypes.func
};

const Permissions = props => (
	<div className="permissions-wrap">
		<div className="permissions-wrap__items">
			<ClonePermissionsForm {...props}/>
			{ props.permissionsList.map(entity => (
				<div className="permissions-wrap--item" key={entity.name}>
					<Control
						placeholder={entity.placeholder}
						name={entity.name}
						isOpen={entity.isOpen}
						isSubPermission={entity.isSubPermission || false}
						options={entity.options}
						intl={props.intl}
						onToggle={props.permissionsControlToggle}
						onToggleSelect={props.permissionControlToggleSelectValue}
					/>
				</div>
			)) }
		</div>

		<div className="permissions-wrap__buttons">
			{ props.can('edit') &&  (
				<button
					onClick={() => (
						props.permissionsControlSave(props.routeParams.id)
					)}
					className="ui-btn ui-btn-primary save">
					{props.intl('Save')}
				</button>
			)}
			<button
				onClick={() => props.permissionControlCancel()}
				className="ui-btn ui-btn-cancel cancel">{props.intl('Cancel')}</button>
		</div>
	</div>
);

const ClonePermissionsForm = reduxForm({ form: 'clonePermissionsForm' })(props =>
	<form onSubmit={props.handleSubmit(props.takePermissionFrom)} className="clone-permissions-form">
		<Field
			name='clone_permission_admin_id'
			placeholder={props.intl('Take permissions from:')}
			component={SelectField}
			searchable={false}
			multi={false}
			options={props.admins}
		/>
		<button className="ui-btn ui-btn-primary save" type="submit">
			Take permissions from
		</button>
	</form>
);

Permissions.propTypes = propTypes;
export default Permissions;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/permissions/main.js